import { render, staticRenderFns } from "./QuotationSelectEmissionType.vue?vue&type=template&id=87895674&scoped=true"
import script from "./QuotationSelectEmissionType.vue?vue&type=script&lang=js"
export * from "./QuotationSelectEmissionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87895674",
  null
  
)

export default component.exports